/* eslint-disable flowtype/require-return-type */
/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import SimpleSelect from '/client/src/components/forms/select';
import SimpleInput from '/client/src/components/forms/simpleInput';
import Switcher from '/client/src/components/switcher';
import AddGuestPageTable from './body';
import { POST } from '/client/src/api';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import NProgressCustom from '/client/src/components/nProgress';
import CssPinner from '/client/src/components/csspinner';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { GetErrorValidation } from '/client/src/utils/errorMessageValidation';
import _ from 'lodash';

import './styles.scss';

type PropsType = {
  eventId: string | number
};

const AddGuestPage = (props: PropsType): React.Element<'div'> => {
  const [ticketType, setTicketType] = React.useState(0);
  const [selectedTicketQuestions, setSelectedTicketQuestions] = React.useState([]);
  const [ticketMethod, setTicketMethod] = React.useState('Complimentary');
  const [ticketConfirm, setTicketConfirm] = React.useState(false);
  const [ticketConfirmVal, ticketConfirmSetVal] = React.useState('');
  const [notes, handleChangeInput] = React.useState('');
  const [isSubmited, handleSubmited] = React.useState(false);
  const [table, setTableData] = React.useState([]);
  const [isLimit, setTableLimit] = React.useState(false);

  const GUEST_LIMIT = 500;
  const context = React.useContext(EventDetailContainerContext);
  const defaultContext = React.useContext(DefaultContainerContext);
  const scheduleId = _.get(
    _.find(_.get(context, 'eventDetail.schedules', {}), (s: {}): {} => s.event_id === props.eventId),
    'id', null);

  React.useEffect(() => {
    const questions = _.get(context, 'eventDetail.questions', []);
    const arr = [];

    questions.forEach((question: any): any => {
      if (question.applied_to_ticket_id.includes(ticketType)) {
        arr.push(question);
      }
    });

    setSelectedTicketQuestions(arr);
  }, [ticketType]);

  const handleChangeTableData = (data) => {
    setTableData(data);
    validateTableRowsQuantity(data);
  };

  const validateTableRowsQuantity = (data) => {
    const filtered = data.filter(el => el.some(x => x.value));
    const isValid = _.size(filtered) <= GUEST_LIMIT;

    if (!isValid) {
      setTableLimit(true);
      defaultContext.handleShowSystemDialog(true, {
        systemDialogType: 'warning',
        systemDialogTitle: 'Hmmm...',
        systemDialogContent: `You can only add ${GUEST_LIMIT} guests at a time.
        To import more than ${GUEST_LIMIT} guests, submit several lists.`
      });
    } else {
      setTableLimit(false);
    }
  };

  const validateTable = (): any => {
    let isValid = true;

    const filtered = table.filter(el => el.some(x => x.value));

    filtered.map(el => el.map((x, i) => {
      if (!x.value &&
        (i === 0 ||   // customer_first_name
          i === 1 ||  // customer_last_name
          i === 2 ||  // customer_email_address
          i === 4)) {
        isValid = false;
      }

      if (i === 4 && x.value > 50) {
        isValid = false;

        defaultContext.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'You can only add 50 tickets per 1 guest at a time.'
        });
      }
    }));

    setTableData(prevState => {
      const filtered = prevState.filter(el => el.some(x => x.value));

      return [
        ...filtered.map(el => el.map((x, i) =>
        ({
          ...x,
          hint: !x.value &&
            (i === 0 ||   // customer_first_name
              i === 1 ||  // customer_last_name
              i === 2 ||  // customer_email_address
              i === 4)    // quantity
            ?
            'not-valid' : i === 4 && x.value > 50 ? 'not-valid' : 'valid'
        })
        ))
      ];
    });

    handleSubmited(prevState => !prevState);
    return isValid;
  };

  const getTicketsWithoutEmptyLines = (): any => {
    const res = _.map(table, (r: []): {} => {
      if (_.size(r[0].value) && _.size(r[1].value) && _.size(r[2].value) && _.size(r[4].value)) {
        return {
          customer_first_name: r[0].value,
          customer_last_name: r[1].value,
          customer_email_address: r[2].value,
          customer_phone_number: r[3].value,
          id: ticketType,
          quantity: r[4].value,
          question_answers: r.filter((cell: any): any => cell.hasOwnProperty('id')).map((cell: any): any => {
              return {
                id: cell.id,
                answers: [`${cell.value}`]
              };
            }),
          remark: r[5].value
        };
      }
    });

    return res.filter(el => el);
  };

  const handleSave = async () => {
    const isValid = validateTable();

    if (!isValid || !table.length) return;

    try {
      CssPinner(document.body, true);
      NProgressCustom(true);

      const ticketsWithoutEmptyLines = getTicketsWithoutEmptyLines();

      if (!_.size(ticketsWithoutEmptyLines)) return;

      const data = {
        auto_increase_stock: false,
        email_notify_content: ticketConfirmVal,
        event_schedule_id: scheduleId,
        import_type: ticketMethod,
        need_send_confirm_email: ticketConfirm,
        tickets: ticketsWithoutEmptyLines.filter(x => x)
      };

      const { success } = await POST(`/api/v1/1/events/${props.eventId}/attendees/import`, data);

      if (success) {
        CssPinner(document.body, false);
        NProgressCustom(false);

        defaultContext.handleShowSystemDialog(true, {
          systemDialogType: 'success',
          systemDialogTitle: 'Great!',
          systemDialogContent: 'Guest(s) successfully added'
        });
        setTableData(null);
        handleSubmited(prevState => !prevState);
      }
    } catch (e) {
      CssPinner(document.body, false);
      NProgressCustom(false);
      defaultContext.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: <GetErrorValidation data={e.data} />
      });
    }
  };

  return (
    <div className="panel panel-default panel-page AddGuestPage">
      <div className="panel-heading panel-heading-color4">
        <div className="panel-title">
          <span>Add Guests</span>
        </div>
      </div>
      <div className="panel-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <SimpleSelect
                value={ticketType}
                label='Select Ticket Type'
                items={[
                  {
                    label: 'Choose a ticket...',
                    value: 0
                  },
                  ...(_.map(_.get(context, 'eventDetail.tickets', []), (_t: {}): {} => {
                    return {
                      label: _t.name,
                      value: _t.id
                    };
                  }))
                ]}
                callBack={(e: any) => {
                  setTicketType(e.target.value);
                }}
              />

              {ticketType !== 0 ?
                <>
                  <SimpleSelect
                    value={ticketMethod}
                    label='Select Method'
                    items={[
                      {
                        label: 'Complimentary',
                        value: 'Complimentary'
                      },
                      {
                        label: 'Cash',
                        value: 'Cash'
                      },
                      {
                        label: 'Check',
                        value: 'Check'
                      }
                    ]}
                    callBack={(e: any) => {
                      setTicketMethod(e.target.value);
                    }}
                  />

                  <SimpleInput
                    label='Notes'
                    name='Notes'
                    id='Notes'
                    value={notes}
                    onChange={(e: any) => {
                      handleChangeInput(e.target.value);
                    }}
                  />

                  <div className="form-group">
                    <label>Guest Data</label>
                    <div className='guest-table-hint'>(Copy and paste guest information in the table below. Only 500 guests can be imported at a time.)</div>
                    <div className='AddGuestPageTable_wrapper'>
                      <AddGuestPageTable
                        setTableData={handleChangeTableData}
                        table={table}
                        isSubmited={isSubmited}
                        isLimit={isLimit}
                        ticketQuestions={selectedTicketQuestions}
                      />
                    </div>
                  </div>

                  <br />

                  <Switcher
                    className='form-switcher pull-left'
                    id='AddGuestPageConfirm'
                    index='AddGuestPageConfirm'
                    checked={ticketConfirm}
                    onCallback={() => {
                      setTicketConfirm(!ticketConfirm);
                    }}
                    label='Send a ticket confirmation to guest'
                  />

                  {ticketConfirm &&
                    <>
                      <br />
                      <div className="form-group SimpleInput">
                        <label htmlFor="adi">Additional Information to be included in the email</label>
                        <textarea
                          // type="text"
                          id='adi'
                          className="form-control"
                          rows="10"
                          value={ticketConfirmVal}
                          onChange={(e: any) => {
                            ticketConfirmSetVal(e.target.value);
                          }}
                        />
                      </div>
                      <br />
                    </>
                  }

                  <div className="form-group">
                    <div className="pull-right">
                      <button className="btn btn-pink" onClick={handleSave}>Add Guests</button>
                    </div>
                  </div>
                </> : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddGuestPage;
